export enum SchedulerApiUrls {
    GetPlansScheduled='/api/ScheduledPlan/GetPlansScheduled',
    UpdateSchedulerInstance='/api/ScheduledPlan/UpdateExceptionDate',
    CreateSchedulerInstance='/api/ScheduledPlan/CreateExceptionDate',
    RemoveSchedulerInstance='/api/ScheduledPlan/RemoveExceptionDate'
  }